"use strict";

window.jQuery = require('./app/jquery');
// window.jRespond = require('./app/jRespond');
// require('./app/jquery.fitvids');
// require('./app/jquery.stellar');
require('./app/slick');
// require('./app/jquery.magnific-popup');
// require('./app/jquery.waitforimages');
// require('./app/jquery.waypoints');
// require('./app/jquery.validate');
// require('./app/simple-scrollbar');
// require('./app/functions');

// require('./bootstrap');
require('./vendor.min');
require('./../plugins/fancybox/jquery.fancybox.min');
require('./../plugins/nice-select/jquery.nice-select.min');
window.AOS = require('./../plugins/aos/aos.min');
require('./../plugins/slick/slick.min');
require('./../plugins/counter-up/jquery.counterup.min');
require('./../plugins/counter-up/jquery.waypoints.min');
require('./custom');
require('./advisor')
// require('./app/footer');
